module.exports = __webpack_public_path__ + "static/images/banner3_042225c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner3.png
// module id = 222
// module chunks = 1